import IExpertiseData from "../../interfaces/IExpertiseData";

const ExpertiseData: IExpertiseData[] = [
  {
    expertiseTitle: "Backend Engineering",
    description:
      "Enterprise-level experience building and delivering complex web services and APIs, with focus on atomic transactions (payments), idempotency, event-driven architecture, observability, and security.",
    descriptionHighlight: undefined,
    graphicPath: "/expertise/software-development.png",
  },
  {
    expertiseTitle: "Frontend Engineering",
    description:
      "2 years of frontend experience building with legacy & modern patterns/frameworks (Vue2, Vue3, Angular, React).",
    descriptionHighlight:
      "Meticulous about Responsiveness - Try on Mobile/Resize this site!",
    graphicPath: "/expertise/frontend-development.png",
  },
  {
    expertiseTitle: "AI & Engineering",
    description:
      "Part of Xero's Early AI adopter department. Practical experience building reusable AI workflows, AI-powered E2E tests, and development tooling that improves velocity and quality consistency. Comfortable working at the frontier of how AI is changing how software gets built.",
    descriptionHighlight: undefined,
    graphicPath: "/expertise/web-design.png",
  },
];

export default ExpertiseData;
